// extracted by mini-css-extract-plugin
module.exports = {"default":"DOMButtonOrA_default__14ULL"};